import React from "react";

class NotFound extends React.Component{

    render(){
        return(
            <div>
                <h2>Error 404</h2>
                <div>
                    <h3>Oops! Page not found.</h3>
                    <p>
                        We could not find the page you were looking for.
                        Meanwhile, you may <a href="/">return to dashboard</a>.
                    </p>
                </div>
            </div>
        )
    }
}

export default NotFound


// WEBPACK FOOTER //
// ./src/views/etc/NotFound.js